import React from 'react';
import { Tooltip, IconButton, Typography, Box, Stack } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditIcon from '@mui/icons-material/Edit';
import PostAddIcon from '@mui/icons-material/PostAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import InfoIcon from '@mui/icons-material/Info';
import PrintDisabledIcon from '@mui/icons-material/PrintDisabled';
import HouseIcon from '@mui/icons-material/House';
import CheckIcon from '@mui/icons-material/Check';
import { formatDateTime, formatDate } from './functions';
import Iconify from '../components/Iconify';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import Done from '@mui/icons-material/Done';
import DoneAll from '@mui/icons-material/DoneAll';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import RemoveIcon from '@mui/icons-material/Remove';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setExternalOrderId } from './redux-actions';
import palette from '../theme/palette';

export const olOrderColumns = (
  handleDetailsCheck,
  handleAccomodationCheck,
  handleConfirmStatus
) => [
  {
    field: 'Szczegóły',
    width: 100,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    resizable: false,
    renderCell: params => (
      <>
        <Tooltip title="Szczegóły">
          <IconButton
            color="primary"
            onClick={() => handleDetailsCheck(params.row, true)}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
        {/* <Tooltip title="Zakwateruj">
          <span>
            <IconButton
              disabled={params.row.accommodated}
              color="primary"
              onClick={() => handleAccomodationCheck(params.row.id, params.row.identifier)}
            >
              <HouseIcon />
            </IconButton>
          </span>
        </Tooltip> */}
        <Tooltip title="Potwierdź zamówienie">
          <span>
            <IconButton
              disabled={params.row.state == 'CON'}
              color="primary"
              onClick={() => handleConfirmStatus(params.row.id, params.row.identifier)
              }
            >
              <CheckIcon />
            </IconButton>
          </span>
        </Tooltip>
      </>
    )
  },
  { field: 'identifier', headerName: 'Numer dok.', width: 140, hide: false },
  {
    field: 'agreement_number',
    headerName: 'Numer umowy',
    width: 140,
    hide: false
  },
  {
    field: 'participant_name',
    headerName: 'Uczestnik',
    width: 140,
    hide: false
  },
  {
    field: 'state_name',
    headerName: 'Status',
    width: 220,
    renderCell: params => <StateColumn {...params} />,
    hide: false
  },
  { field: 'event_name', headerName: 'Impreza', width: 140, hide: false },
  { field: 'camp_name', headerName: 'Turnus', width: 140, hide: false },
  { field: 'resort_name', headerName: 'Ośrodek', width: 140, hide: false },
  {
    field: 'sum_of_advances_col',
    headerName: 'Suma zaliczek',
    width: 140,
    hide: false
  },
  {
    field: 'order_value_col',
    headerName: 'Wartość zamówienia',
    width: 140,
    hide: false
  },
  {
    field: 'left_to_pay_col',
    headerName: 'Pozostało do zapłaty',
    width: 140,
    hide: false
  },
  {
    field: 'transport_departure_description',
    headerName: 'Wyjazd',
    width: 140,
    hide: false
  },
  {
    field: 'transport_return_description',
    headerName: 'Powrót',
    width: 140,
    hide: false
  },
  { field: 'promotion_name', headerName: 'Rabat', width: 140, hide: false },
  {
    field: 'promotions_sum',
    headerName: 'Suma rabatów',
    width: 140,
    hide: false
  },
  { field: 'participant_pesel', headerName: 'Pesel', width: 140, hide: false },
  { field: 'pl_gender_name', headerName: 'Płeć', width: 140, hide: false },
  { field: 'guardian_name', headerName: 'Opiekun', width: 140, hide: false },
  {
    field: 'guardian_correspondence_email',
    headerName: 'Email',
    width: 140,
    hide: false
  },
  {
    field: 'guardian_phone',
    headerName: 'Numer telefonu',
    width: 140,
    hide: false
  },
  {
    field: 'guardian_province_display',
    headerName: 'Województwo opiekuna',
    width: 140,
    hide: false
  },
  {
    field: 'agreement_date',
    headerName: 'Data umowy',
    width: 140,
    hide: false
  },
  {
    field: 'agreement_signing_date',
    headerName: 'Data podpisania umowy',
    width: 140,
    hide: false,
    valueGetter: params => formatDateTime(params.row.agreement_signing_date)
  },
  {
    field: 'participant_birth_date',
    headerName: 'Data urodzenia',
    width: 160,
    hide: false
  },
  {
    field: 'return_agreement',
    headerName: 'Zwrot umowy',
    width: 140,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'return_of_health_card',
    headerName: 'Zwrot karty zdrowia',
    width: 200,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'annex_return',
    headerName: 'Zwrot aneksu',
    width: 120,
    align: 'center',
    renderCell: params => <NullBooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'reservation_date',
    headerName: 'Data rezerwacji',
    width: 160,
    hide: false,
    valueGetter: params => formatDateTime(params.row.created_at)
  },
  {
    field: 'accommodated',
    headerName: 'Zakwaterowano',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'classification',
    headerName: 'Kwalifikacja',
    width: 160,
    align: 'center',
    hide: false
  },
  {
    field: 'advance_payment_date',
    headerName: 'Termin zaliczki',
    width: 160,
    hide: false
  },
  {
    field: 'final_payment_date',
    headerName: 'Termin zapłaty końcowej',
    width: 240,
    hide: false
  },
  { field: 'comments', headerName: 'Uwagi', width: 240, hide: false },
  {
    field: 'age_range',
    headerName: 'Przedział wiekowy',
    width: 240,
    hide: false
  },
  { field: 'contractor_nip', headerName: 'NIP', width: 240, hide: false },
  {
    field: 'shared_accommodation_info',
    headerName: 'Uwagi dotyczące zakwaterowania',
    width: 240,
    hide: false
  },
  { field: 'diet', headerName: 'Dieta', width: 120, hide: false },
  {
    field: 'participant_diet',
    headerName: 'Dieta uczestnika dodatkowe informacje',
    width: 120,
    hide: false
  },
  {
    field: 'participant_regular_medication',
    headerName: 'Stałe leki uczestnika',
    width: 120,
    hide: false
  },
  {
    field: 'participant_behavior',
    headerName: 'Zachowanie uczestnika',
    width: 120,
    hide: false
  },
  {
    field: 'participant_other_comments',
    headerName: 'Inne uwagi dotyczące uczestnika',
    width: 120,
    hide: false
  },
  {
    field: 'participant_siblings_and_friends',
    headerName: 'Rodzeństwo/Przyjaciele',
    width: 120,
    hide: false
  },
  {
    field: 'participant_province_display',
    headerName: 'Województwo',
    width: 140,
    hide: false
  },
  {
    field: 'accounting_notes',
    headerName: 'Uwagi księgowe',
    width: 240,
    hide: false
  },
  {
    field: 'last_change_date',
    headerName: 'Data ostatniej zmiany na zamówieniu',
    width: 160,
    hide: false,
    valueGetter: params => formatDateTime(params.row.last_change_date)
  },
  {
    field: 'debit_note_issued',
    headerName: 'Wystawiona nota obciążeniowa',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'deductions',
    headerName: 'Potrącenia',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'qualification_card_returned',
    headerName: 'Wypełniono kartę',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'shared_accommodation_changed',
    headerName: 'Alarmuj o wspólnym zakwaterowaniu',
    width: 160,
    align: 'center',
    renderCell: params => <AlertColumn {...params} />,
    hide: false
  }
];

export const plOrderColumns = (
  handleDetailsCheck,
  handleAccomodationCheck,
  handleConfirmStatus
) => [
  {
    field: 'Szczegóły',
    width: 100,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    resizable: false,
    renderCell: params => (
      <>
        <Tooltip title="Szczegóły">
          <IconButton
            color="primary"
            onClick={() => handleDetailsCheck(params.row, true)}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Potwierdź zamówienie">
          <span>
            <IconButton
              disabled={params.row.state == 'CON'}
              color="primary"
              onClick={() => handleConfirmStatus(params.row.id, params.row.identifier)
              }
            >
              <CheckIcon />
            </IconButton>
          </span>
        </Tooltip>
      </>
    )
  },
  { field: 'identifier', headerName: 'Numer dok.', width: 140, hide: false },
  {
    field: 'agreement_number',
    headerName: 'Numer umowy',
    width: 140,
    hide: false
  },
  {
    field: 'participant_name',
    headerName: 'Uczestnik',
    width: 140,
    hide: false
  },
  {
    field: 'state_name',
    headerName: 'Status',
    width: 220,
    renderCell: params => <StateColumn {...params} />,
    hide: false
  },
  { field: 'event_name', headerName: 'Impreza', width: 140, hide: false },
  { field: 'camp_name', headerName: 'Turnus', width: 140, hide: false },
  {
    field: 'sum_of_advances_col',
    headerName: 'Suma zaliczek',
    width: 140,
    hide: false
  },
  {
    field: 'order_value_col',
    headerName: 'Wartość zamówienia',
    width: 140,
    hide: false
  },
  {
    field: 'left_to_pay_col',
    headerName: 'Pozostało do zapłaty',
    width: 140,
    hide: false
  },
  { field: 'promotion_name', headerName: 'Rabat', width: 140, hide: false },
  { field: 'participant_pesel', headerName: 'Pesel', width: 140, hide: false },
  { field: 'pl_gender_name', headerName: 'Płeć', width: 140, hide: false },
  { field: 'guardian_name', headerName: 'Opiekun', width: 140, hide: false },
  {
    field: 'guardian_correspondence_email',
    headerName: 'Email',
    width: 140,
    hide: false
  },
  {
    field: 'guardian_phone',
    headerName: 'Numer telefonu',
    width: 140,
    hide: false
  },
  {
    field: 'agreement_date',
    headerName: 'Data umowy',
    width: 140,
    hide: false
  },
  {
    field: 'participant_birth_date',
    headerName: 'Data urodzenia',
    width: 160,
    hide: false
  },
  {
    field: 'return_agreement',
    headerName: 'Zwrot umowy',
    width: 140,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'return_of_health_card',
    headerName: 'Zwrot karty zdrowia',
    width: 200,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'annex_return',
    headerName: 'Zwrot aneksu',
    width: 120,
    align: 'center',
    renderCell: params => <NullBooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'reservation_date',
    headerName: 'Data rezerwacji',
    width: 160,
    hide: false,
    valueGetter: params => formatDateTime(params.row.created_at)
  },
  {
    field: 'accommodated',
    headerName: 'Zakwaterowano',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'qualification_card_returned',
    headerName: 'Wypełniono kartę',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'classification',
    headerName: 'Kwalifikacja',
    width: 160,
    align: 'center',
    hide: false
  },
  {
    field: 'advance_payment_date',
    headerName: 'Termin zaliczki',
    width: 160,
    hide: false
  },
  {
    field: 'final_payment_date',
    headerName: 'Termin zapłaty końcowej',
    width: 240,
    hide: false
  },
  { field: 'comments', headerName: 'Uwagi', width: 240, hide: false },
  { field: 'contractor_nip', headerName: 'NIP', width: 240, hide: false },
  { field: 'variant', headerName: 'Wariant', width: 120, hide: false },
  {
    field: 'accounting_notes',
    headerName: 'Uwagi księgowe',
    width: 240,
    hide: false
  },
  {
    field: 'debit_note_issued',
    headerName: 'Wystawiona nota obciążeniowa',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'deductions',
    headerName: 'Potrącenia',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  }
];

export const zsOrderColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    resizable: false,
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row, true)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'identifier', headerName: 'Numer dok.', width: 140, hide: false },
  {
    field: 'agreement_number',
    headerName: 'Numer umowy',
    width: 140,
    hide: false
  },
  {
    field: 'state_name',
    headerName: 'Status',
    width: 220,
    renderCell: params => <StateColumn {...params} />,
    hide: false
  },
  { field: 'resort_name', headerName: 'Ośrodek', width: 140, hide: false },
  { field: 'school_name', headerName: 'Nazwa szkoły', width: 140, hide: false },
  {
    field: 'school_city',
    headerName: 'Miasto szkoły',
    width: 140,
    hide: false
  },
  {
    field: 'school_province_display',
    headerName: 'Województwo szkoły',
    width: 140,
    hide: false
  },
  {
    field: 'school_street_address',
    headerName: 'Ulica szkoły',
    width: 140,
    hide: false
  },
  {
    field: 'school_postal_code',
    headerName: 'Kod pocztowy szkoły',
    width: 140,
    hide: false
  },
  {
    field: 'educational_trip_name',
    headerName: 'Wycieczka edukacyjna',
    width: 140,
    hide: false
  },
  { field: 'activities_names', headerName: 'Zajęcia', width: 140, hide: false },
  {
    field: 'participants_age',
    headerName: 'Wiek uczestników',
    width: 140,
    hide: false
  },
  {
    field: 'boys_count',
    headerName: 'Liczba chłopców',
    width: 140,
    hide: false
  },
  {
    field: 'girls_count',
    headerName: 'Liczba dziewczynek',
    width: 140,
    hide: false
  },
  {
    field: 'participants_count',
    headerName: 'Liczba uczestników',
    width: 140,
    hide: false
  },
  {
    field: 'participants_and_guardians_count',
    headerName: 'Liczba uczestników i opiekunów',
    width: 140,
    hide: false
  },
  {
    field: 'paintball_participants_count',
    headerName: 'Liczba uczestników gry paintball’owej',
    width: 140,
    hide: false
  },
  {
    field: 'free_guardian_man_count',
    headerName: 'Liczba opiekunów (mężczyzn) gratis',
    width: 140,
    hide: false
  },
  {
    field: 'free_guardian_woman_count',
    headerName: 'Liczba opiekunów (kobiet) gratis',
    width: 140,
    hide: false
  },
  {
    field: 'paid_guardian_man_count',
    headerName: 'Liczba opiekunów (mężczyzn) płatnych',
    width: 140,
    hide: false
  },
  {
    field: 'paid_guardian_woman_count',
    headerName: 'Liczba opiekunów (kobiet) płatnych',
    width: 140,
    hide: false
  },
  {
    field: 'driver_on_resort',
    headerName: 'Kierowca pozostaje w ośrodku',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'agreement_signer_name',
    headerName: 'Imię osoby upoważnionej do podpisania umowy',
    width: 140,
    hide: false
  },
  {
    field: 'agreement_signer_surname',
    headerName: 'Nazwisko osoby upoważnionej do podpisania umowy',
    width: 140,
    hide: false
  },
  {
    field: 'office_representative_name',
    headerName: 'Imię osoby reprezentującej szkołę w kontaktach z biurem',
    width: 140,
    hide: false
  },
  {
    field: 'office_representative_surname',
    headerName: 'Nazwisko osoby reprezentującej szkołę w kontaktach z biurem',
    width: 140,
    hide: false
  },
  {
    field: 'office_representative_phone',
    headerName:
      'Nr. telefonu osoby reprezentującej szkołę w kontaktach z biurem',
    width: 140,
    hide: false
  },
  {
    field: 'office_representative_correspondence_email',
    headerName: 'E-mail osoby reprezentującej szkołę w kontaktach z biurem',
    width: 140,
    hide: false
  },
  {
    field: 'additional_participants_info',
    headerName: 'Informacja nt. chorób dzieci, dysfunkcji, diet, uczuleń itp.',
    width: 140,
    hide: false
  },
  {
    field: 'additional_participants_class_info',
    headerName:
      '​Dodatkowe informacje na temat ilości klas i ilość osób w nich',
    width: 140,
    hide: false
  },
  {
    field: 'annex_return',
    headerName: 'Zwrot aneksu',
    width: 120,
    align: 'center',
    renderCell: params => <NullBooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'return_of_health_card',
    headerName: 'Zwrot listy do ubezpieczenia',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'paintball_game',
    headerName: 'Paintball',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  { field: 'period_name', headerName: 'Termin', width: 140, hide: false },
  { field: 'period_from', headerName: 'Termin od', width: 140, hide: false },
  { field: 'period_to', headerName: 'Termin do', width: 140, hide: false },
  {
    field: 'reservation_date',
    headerName: 'Data rezerwacji',
    width: 160,
    hide: false,
    valueGetter: params => formatDateTime(params.row.created_at)
  },
  {
    field: 'sum_of_advances_col',
    headerName: 'Suma zaliczek',
    width: 140,
    hide: false
  },
  {
    field: 'order_value_col',
    headerName: 'Wartość zamówienia',
    width: 140,
    hide: false
  },
  {
    field: 'left_to_pay_col',
    headerName: 'Pozostało do zapłaty',
    width: 140,
    hide: false
  },
  { field: 'school_nip', headerName: 'NIP', width: 140, hide: false },
  {
    field: 'accounting_notes',
    headerName: 'Uwagi księgowe',
    width: 240,
    hide: false
  },
  { field: 'promotion_name', headerName: 'Rabat', width: 140, hide: false },
  {
    field: 'last_change_date',
    headerName: 'Data ostatniej zmiany na zamówieniu',
    width: 160,
    hide: false,
    valueGetter: params => formatDateTime(params.row.last_change_date)
  },
  {
    field: 'debit_note_issued',
    headerName: 'Wystawiona nota obciążeniowa',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'deductions',
    headerName: 'Potrącenia',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} yesno={true} />,
    hide: false
  },
  {
    field: 'deductions_sum',
    headerName: 'Suma potrąceń',
    width: 140,
    hide: false
  },
  {
    field: 'return_agreement',
    headerName: 'Zwrot umowy',
    width: 140,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'agreement_signing_date',
    headerName: 'Data podpisania umowy',
    width: 140,
    hide: false,
    valueGetter: params => formatDateTime(params.row.agreement_signing_date)
  }
];

export const wrOrderColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    resizable: false,
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row, true)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'identifier', headerName: 'Numer dok.', width: 140, hide: false },
  {
    field: 'agreement_number',
    headerName: 'Numer umowy',
    width: 140,
    hide: false
  },
  { field: 'guardian_name', headerName: 'Kontrahent', width: 140, hide: false },
  {
    field: 'state_name',
    headerName: 'Status',
    width: 220,
    renderCell: params => <StateColumn {...params} />,
    hide: false
  },
  { field: 'resort_name', headerName: 'Ośrodek', width: 140, hide: false },
  { field: 'activities_names', headerName: 'Zajęcia', width: 140, hide: false },
  {
    field: 'guardian_correspondence_email',
    headerName: 'Email',
    width: 140,
    hide: false
  },
  {
    field: 'guardian_phone',
    headerName: 'Numer telefonu',
    width: 140,
    hide: false
  },
  {
    field: 'guardian_province_display',
    headerName: 'Województwo',
    width: 140,
    hide: false
  },
  { field: 'guardian_pesel', headerName: 'Pesel', width: 140, hide: false },
  { field: 'guardian_city', headerName: 'Miasto', width: 140, hide: false },
  {
    field: 'guardian_postal_code',
    headerName: 'Kod pocztowy',
    width: 160,
    hide: false
  },
  {
    field: 'guardian_street_address',
    headerName: 'Adres',
    width: 200,
    hide: false
  },
  {
    field: 'wr_adults_count',
    headerName: 'Liczba dorosłych',
    width: 200,
    hide: false
  },
  {
    field: 'wr_3_12_children_count',
    headerName: 'Liczba dzieci od 3 do 12 lat',
    width: 200,
    hide: false
  },
  {
    field: 'wr_0_3_children_count',
    headerName: 'Liczba dzieci poniżej 3 lat',
    width: 200,
    hide: false
  },
  {
    field: 'wr_6_plus_children_count',
    headerName: 'Liczba dzieci powyżej 6 r. ż.',
    width: 200,
    hide: false
  },
  {
    field: 'wr_0_5_children_count',
    headerName: 'Liczba dzieci poniżej 5 lat',
    width: 200,
    hide: false
  },
  {
    field: 'accomodation_name',
    headerName: 'Zakwaterowanie',
    width: 140,
    hide: false
  },
  {
    field: 'accommodated',
    headerName: 'Zakwaterowano',
    width: 140,
    hide: false
  },
  {
    field: 'wr_has_animal',
    headerName: 'Zwierzątko',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  { field: 'wr_diets_names', headerName: 'Diety', width: 140, hide: false },
  {
    field: 'annex_return',
    headerName: 'Zwrot aneksu',
    width: 120,
    align: 'center',
    renderCell: params => <NullBooleanColumn {...params} />,
    hide: false
  },
  { field: 'period_name', headerName: 'Termin', width: 140, hide: false },
  { field: 'period_from', headerName: 'Termin od', width: 140, hide: false },
  { field: 'period_to', headerName: 'Termin do', width: 140, hide: false },
  {
    field: 'reservation_date',
    headerName: 'Data rezerwacji',
    width: 160,
    hide: false,
    valueGetter: params => formatDateTime(params.row.created_at)
  },
  {
    field: 'sum_of_advances_col',
    headerName: 'Suma zaliczek',
    width: 140,
    hide: false
  },
  {
    field: 'order_value_col',
    headerName: 'Wartość zamówienia',
    width: 140,
    hide: false
  },
  {
    field: 'left_to_pay_col',
    headerName: 'Pozostało do zapłaty',
    width: 140,
    hide: false
  },
  {
    field: 'accounting_notes',
    headerName: 'Uwagi księgowe',
    width: 240,
    hide: false
  },
  { field: 'promotion_name', headerName: 'Rabat', width: 140, hide: false },
  {
    field: 'last_change_date',
    headerName: 'Data ostatniej zmiany na zamówieniu',
    width: 160,
    hide: false,
    valueGetter: params => formatDateTime(params.row.last_change_date)
  },
  {
    field: 'debit_note_issued',
    headerName: 'Wystawiona nota obciążeniowa',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'deductions',
    headerName: 'Potrącenia',
    width: 160,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'return_agreement',
    headerName: 'Zwrot umowy',
    width: 140,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />,
    hide: false
  },
  {
    field: 'advance_payment_date',
    headerName: 'Termin zaliczki',
    width: 160,
    hide: false
  },
  {
    field: 'final_payment_date',
    headerName: 'Termin zapłaty końcowej',
    width: 240,
    hide: false
  },
  {
    field: 'agreement_date',
    headerName: 'Data umowy',
    width: 140,
    hide: false
  },
  {
    field: 'agreement_signing_date',
    headerName: 'Data podpisania umowy',
    width: 140,
    hide: false,
    valueGetter: params => formatDateTime(params.row.agreement_signing_date)
  }
];

export const participantColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Imię i nazwisko', width: 180, hide: false },
  {
    field: 'birth_date',
    headerName: 'Data urodzenia',
    width: 180,
    hide: false
  },
  {
    field: 'gender',
    headerName: 'Płeć',
    width: 140,
    hide: false,
    renderCell: params => params.value === 'boy'
      ? 'Chłopiec'
      : params.value === 'girl'
        ? 'Dziewczynka'
        : ''
  },
  { field: 'pesel', headerName: 'Pesel', width: 140, hide: false },
  { field: 'city', headerName: 'Miasto', width: 140, hide: false },
  { field: 'postal_code', headerName: 'Kod pocztowy', width: 160, hide: false },
  { field: 'street_address', headerName: 'Adres', width: 200, hide: false }
];

export const purchaserColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Imię i nazwisko', width: 180, hide: false },
  { field: 'phone', headerName: 'Numer telefonu', width: 160, hide: false },
  {
    field: 'correspondence_email',
    headerName: 'E-mail',
    width: 200,
    hide: false
  },
  {
    field: 'type',
    headerName: 'Rodzaj',
    width: 100,
    hide: false,
    renderCell: params => params.value === 'guardian'
      ? 'Opiekun'
      : params.value === 'contractor'
        ? 'Kontrahent'
        : ''
  },
  { field: 'city', headerName: 'Miasto', width: 140, hide: false },
  { field: 'postal_code', headerName: 'Kod pocztowy', width: 220, hide: false },
  { field: 'street_address', headerName: 'Adres', width: 200, hide: false },
  { field: 'nip', headerName: 'NIP', width: 140, hide: false }
];

export const resortColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  {
    field: 'seasons_display',
    headerName: 'Sezony',
    width: 250,
    hide: false,
    flex: 1,
    type: 'array'
  }
];

export const campColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  { field: 'date_from', headerName: 'Data od', width: 140, hide: false },
  { field: 'date_to', headerName: 'Data do', width: 160, hide: false },
  { field: 'season_display', headerName: 'Sezon', width: 160, hide: false }
];

export const eventOlColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false },
  { field: 'resort_display', headerName: 'Ośrodek', width: 160, hide: false },
  { field: 'season_display', headerName: 'Sezon', width: 140, hide: false },
  {
    field: 'age_range_display',
    headerName: 'Przedział wiekowy',
    width: 200,
    hide: false
  },
  {
    field: 'birth_date_from',
    headerName: 'Data urodzenia od',
    width: 180,
    hide: false
  },
  {
    field: 'birth_date_to',
    headerName: 'Data urodzenia do',
    width: 180,
    hide: false
  },
  {
    field: 'is_active',
    headerName: 'Aktywna',
    width: 80,
    hide: false,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />
  },
  { field: 'notes', headerName: 'Uwagi', width: 300, hide: false }
];

export const eventPlColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false },
  { field: 'season_display', headerName: 'Sezon', width: 160, hide: false },
  { field: 'variant1', headerName: 'Wariant 1', width: 140, hide: false },
  { field: 'variant2', headerName: 'Wariant 2', width: 140, hide: false },
  {
    field: 'is_active',
    headerName: 'Aktywna',
    width: 80,
    hide: false,
    align: 'center',
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'birth_date_from',
    headerName: 'Data urodzenia od',
    width: 180,
    hide: false
  },
  {
    field: 'birth_date_to',
    headerName: 'Data urodzenia do',
    width: 180,
    hide: false
  }
];

export const accomodationColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  {
    field: 'seasons_display',
    headerName: 'Sezony',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'resorts_display',
    headerName: 'Ośrodki',
    width: 200,
    hide: false,
    flex: 1
  }
];

export const ageRangeColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  {
    field: 'seasons_display',
    headerName: 'Sezony',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'resorts_display',
    headerName: 'Ośrodki',
    width: 200,
    hide: false,
    flex: 1
  }
];

export const seasonColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  {
    field: 'identifier',
    headerName: 'Identyfikator',
    width: 250,
    hide: false,
    flex: 1
  },
  { field: 'year', headerName: 'Rok', width: 250, hide: false, flex: 1 },
  {
    field: 'season_display',
    headerName: 'Sezon',
    width: 250,
    hide: false,
    flex: 1
  }
];

export const promotionColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'sequence', headerName: 'Kolejność', width: 100, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false },
  { field: 'type_display', headerName: 'Rodzaj', width: 250, hide: false },
  { field: 'gross_value', headerName: 'Wartość', width: 100, hide: false },
  {
    field: 'is_enabled',
    headerName: 'Aktywna',
    width: 120,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  { field: 'season_display', headerName: 'Sezon', width: 120, hide: false },
  {
    field: 'is_connected_with_big_family_card',
    headerName: 'Poł. z kartą dużej rodziny',
    width: 150,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'is_big_family_card',
    headerName: 'Karta dużej rodziny',
    width: 150,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'discount_code',
    headerName: 'Kod promocyjny',
    width: 170,
    hide: false
  },
  {
    field: 'discount_code_from',
    headerName: 'Kod promocyjny od',
    width: 170,
    hide: false
  },
  {
    field: 'discount_code_to',
    headerName: 'Kod promocyjny do',
    width: 170,
    hide: false
  },
  {
    field: 'date_from',
    headerName: 'Data promocji od',
    width: 170,
    hide: false
  },
  { field: 'date_to', headerName: 'Data promocji do', width: 170, hide: false },
  {
    field: 'is_main_promotion',
    headerName: 'Jest główną promocją',
    width: 150,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'main_promotion_display',
    headerName: 'Główna promocja',
    width: 170,
    hide: false
  }
];

export const transportColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  {
    field: 'gross_value',
    headerName: 'Cena brutto (zł)',
    width: 200,
    hide: false
  },
  {
    field: 'season_display',
    headerName: 'Sezon',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'resorts_display',
    headerName: 'Ośrodki',
    width: 200,
    hide: false,
    flex: 1
  }
];
export const transportSeatsControlColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  {
    field: 'resort_display',
    headerName: 'Ośrodek',
    width: 100,
    hide: false,
    flex: 1
  },
  { field: 'type', headerName: 'Rodzaj', width: 100, hide: false },
  {
    field: 'transports_display',
    headerName: 'Transporty',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'camp_display',
    headerName: 'Turnus',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'seats',
    headerName: 'Liczba miejsc',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'taken_seats',
    headerName: 'Zajęte miejsca',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'available_seats',
    headerName: 'Wolne miejsca',
    width: 200,
    hide: false,
    flex: 1
  }
];

export const activityColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  { field: 'type_display', headerName: 'Rodzaj', width: 200, hide: false, flex: 1 },
  { field: 'category_display', headerName: 'Kategoria', width: 200, hide: false, flex: 1 },
  { field: 'seasons_display', headerName: 'Sezony', width: 200, hide: false, flex: 1 },
  { field: 'resorts_display', headerName: 'Ośrodki', width: 200, hide: false, flex: 1 },
  { field: 'periods_display', headerName: 'Termin', width: 200, hide: false, flex: 1 }
];

export const periodColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  {
    field: 'season_display',
    headerName: 'Sezon',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'resorts_display',
    headerName: 'Ośrodki',
    width: 200,
    hide: false,
    flex: 1
  }
];

export const paymentDateRangeColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'date_from', headerName: 'Od', width: 250, hide: false, flex: 1 },
  { field: 'date_to', headerName: 'Do', width: 200, hide: false, flex: 1 },
  {
    field: 'periods_display',
    headerName: 'Terminy',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'packages_display',
    headerName: 'Pakiety',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'minimum_goal_giewartow',
    headerName: 'Cel min Giewartów',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'maximum_goal_giewartow',
    headerName: 'Cel max Giewartów',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'minimum_goal_mrowki',
    headerName: 'Cel min Mrówki',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'maximum_goal_mrowki',
    headerName: 'Cel max Mrówki',
    width: 200,
    hide: false,
    flex: 1
  }
];

export const piggyBankConfigColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'date_from', headerName: 'Data od', width: 150, hide: false, flex: 1 },
  { field: 'date_to', headerName: 'Data do', width: 150, hide: false, flex: 1 },
  { field: 'rate', headerName: 'Mnożnik (%)', width: 150, hide: false, flex: 1 },
  { field: 'entry_valid_days', headerName: 'Ważność pkt (dni)', width: 160, hide: false, flex: 1 },
  { field: 'message', headerName: 'Komunikat na stronę', width: 300, hide: false, flex: 2 },
  {
    field: 'skip_transport',
    headerName: 'Bez transportu',
    width: 150,
    hide: false,
    flex: 1,
    renderCell: params => (params.row.skip_transport ? 'Tak' : 'Nie')
  }
];

const ENTRY_TYPE_LABELS = {
  accrual: 'Naliczenie',
  manual: 'Korekta ręczna',
  spend: 'Wydatek'
};

export const piggyBankEntryColumns = () => [
  { field: 'created_at', headerName: 'Data', width: 180, hide: false, flex: 1, valueFormatter: params => formatDateTime(params.value) },
  {
    field: 'entry_type',
    headerName: 'Typ',
    width: 130,
    hide: false,
    flex: 1,
    renderCell: params => ENTRY_TYPE_LABELS[params.row.entry_type] || params.row.entry_type
  },
  { field: 'amount', headerName: 'Kwota (zł)', width: 120, hide: false, flex: 1 },
  { field: 'amount_remaining', headerName: 'Pozostało (zł)', width: 130, hide: false, flex: 1 },
  {
    field: 'expires_at',
    headerName: 'Wygasa',
    width: 120,
    hide: false,
    flex: 1,
    renderCell: params => {
      if (!params.row.expires_at) {
        return '—';
      }
      const expired = new Date(params.row.expires_at) < new Date();

      return (
        <span style={{ color: expired ? '#9e9e9e' : 'inherit', textDecoration: expired ? 'line-through' : 'none' }}>
          {params.row.expires_at}
        </span>
      );
    }
  },
  { field: 'order_identifier', headerName: 'Zamówienie', width: 140, hide: false, flex: 1 },
  { field: 'description', headerName: 'Opis', width: 220, hide: false, flex: 2 },
  { field: 'author_name', headerName: 'Autor', width: 180, hide: false, flex: 1 }
];

export const documentColumns = (
  handleDetailsCheck,
  handleDownloadDocument,
  handleOpenSendModal,
  handleShowDocument,
  openConfirmationWindow,
  handleDelete,
  openFiscalizationWindow
) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return [
    {
      field: 'Szczegóły',
      width: 296,
      align: 'center',
      disableClickEventBubbling: true,
      headerName: '',
      renderCell: params => (
        <>
          <Tooltip title="Zobacz">
            <IconButton
              color="primary"
              onClick={() => handleShowDocument(params.row)}
            >
              <RemoveRedEyeIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Wyślij">
            <IconButton
              color="primary"
              onClick={() => handleOpenSendModal(params.row)}
            >
              <ForwardToInboxIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Pobierz">
            <IconButton
              variant="contained"
              color="secondary"
              onClick={() => handleDownloadDocument(params.row)}
            >
              <Iconify icon={'ph:file-pdf-bold'} width={20} height={20} />
            </IconButton>
          </Tooltip>
          {params.row.dgcs_sent && !params.row.dgcs_update_required ? (
            <Tooltip title="Dokument wysłany">
              <DoneAll color="primary" />
            </Tooltip>
          ) : params.row.dgcs_status == 1 ? (
            <Tooltip title="Oznacz jako gotowe do wysyłki z DGCS">
              <IconButton
                color="secondary"
                onClick={() => openConfirmationWindow(params.row, true)}
              >
                <Done />
              </IconButton>
            </Tooltip>
          ) : [2, 4].includes(params.row.dgcs_status) ? (
            <Tooltip title="Odznacz jako gotowe do wysyłki z DGCS">
              <IconButton
                color="primary"
                onClick={() => openConfirmationWindow(params.row, false)}
              >
                <Done color="green" />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Dokument w trakcie przetwarzania">
              <Done />
            </Tooltip>
          )}
          {[5, 6, 8].includes(params.row.type) ? (
            params.row.fiscalized ? (
              <Tooltip title="Dokument zafiskalizowany">
                <PrintDisabledIcon color="primary" />
              </Tooltip>
            ) : params.row.fiscalization_error ? (
              <Tooltip title="Wystąpił błąd. Ponów próbę fiskalizacji">
                <IconButton
                  color="error"
                  onClick={() => openFiscalizationWindow(params.row, false, true)
                  }
                >
                  <PrintDisabledIcon />
                </IconButton>
              </Tooltip>
            ) : !params.row.for_fiscalization ? (
              <Tooltip title="Oznacz jako gotowe do fiskalizacji">
                <IconButton
                  color="secondary"
                  onClick={() => openFiscalizationWindow(params.row, true)}
                >
                  <PrintIcon />
                </IconButton>
              </Tooltip>
            ) : params.row.for_fiscalization ? (
              <Tooltip title="Odznacz jako gotowe do fiskalizacji">
                <IconButton
                  color="primary"
                  onClick={() => openFiscalizationWindow(params.row, false)}
                >
                  <PrintIcon color="green" />
                </IconButton>
              </Tooltip>
            ) : (
              <Box height={40} width={40} />
            )
          ) : (
            <Box height={40} width={40} />
          )}
          {params.row.can_edit ? (
            <Tooltip
              title="Edytuj"
              onClick={() => handleDetailsCheck(params.row)}
            >
              <IconButton
                color="primary"
                onClick={() => handleDetailsCheck(params.row)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Box height={40} width={40} />
          )}
          {params.row.can_edit ? (
            <Tooltip title="Usuń" onClick={() => handleDelete(params.row.id)}>
              <IconButton
                color="error"
                onClick={() => handleDelete(params.row.id)}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Box height={40} width={40} />
          )}
        </>
      )
    },
    { field: 'id', headerName: 'ID', width: 50, hide: false },
    { field: 'number', headerName: 'Nr. dokumentu', width: 170, hide: false },
    { field: 'type_display', headerName: 'Typ', width: 140, hide: false },
    {
      field: 'order_number',
      headerName: 'Nr. zamówienia',
      width: 170,
      hide: false,
      renderCell: params => (
        <Typography
          onClick={() => {
            navigate('/employee/orders');
            dispatch(setExternalOrderId(params.row.order));
          }}
          sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'blue' }}
        >
          {params.row.order_number}
        </Typography>
      )
    },
    {
      field: 'total_due_difference',
      headerName: 'Wartość brutto (zł)',
      width: 130,
      hide: false
    },
    {
      field: 'issue_date',
      headerName: 'Data wpływu zaliczki',
      width: 180,
      hide: false
    },
    {
      field: 'created_at',
      headerName: 'Data wystawienia',
      width: 180,
      hide: false,
      valueGetter: params => formatDateTime(params.row.created_at)
    },
    {
      field: 'dgcs_status_display',
      headerName: 'Status',
      width: 180,
      hide: false
    },
    {
      field: 'participant_name',
      headerName: 'Uczestnik',
      width: 150,
      hide: false
    },
    {
      field: 'agreement_number',
      headerName: 'Nr. umowy',
      width: 130,
      hide: false
    },
    { field: 'buyer_name', headerName: 'Kontrahent', width: 150, hide: false },
    { field: 'user_name', headerName: 'Wystawiający', width: 150, hide: false },
    { field: 'source_display', headerName: 'Źródło', width: 150, hide: false }
    // {
    //   field: 'ksef_reference_number',
    //   headerName: 'Nr. KSeF',
    //   width: 150,
    //   hide: false
    // }
  ];
};

export const templateProductColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false },
  { field: 'quantity', headerName: 'Ilość', width: 90, hide: false },
  { field: 'vat_rate', headerName: 'VAT', width: 80, hide: false },
  {
    field: 'gross_price',
    headerName: 'Cena brutto (zł)',
    width: 170,
    hide: false
  },
  {
    field: 'net_price',
    headerName: 'Cena netto (zł)',
    width: 170,
    hide: false
  },
  {
    field: 'gross_value',
    headerName: 'Wartość brutto (zł)',
    width: 185,
    hide: false
  },
  {
    field: 'net_value',
    headerName: 'Wartość netto (zł)',
    width: 180,
    hide: false
  },
  {
    field: 'vat_amount',
    headerName: 'Wartość VAT (zł)',
    width: 180,
    hide: false
  }
];

export const promotionStatisticsColumns = () => [
  { field: 'id', headerName: 'Id', width: 90, hide: true },
  {
    field: 'promotion_name',
    headerName: 'Nazwa',
    width: 90,
    hide: false,
    flex: 1
  },
  {
    field: 'promotion_date_range',
    headerName: 'Data ważności',
    width: 90,
    hide: false,
    flex: 1
  },
  {
    field: 'promotion_expense',
    headerName: 'Wydatki (zł)',
    width: 90,
    hide: false,
    flex: 1
  }
];

export const eventSlotsAvailabilityColumns = () => [
  { field: 'id', headerName: 'id', width: 200, hide: true },
  { field: 'event_name', headerName: 'Impreza', width: 350, hide: false },
  { field: 'resort_name', headerName: 'Ośrodek', width: 140, hide: false },
  { field: 'camp_name', headerName: 'Turnus', width: 280, hide: false },
  { field: 'gross_value', headerName: 'Cena', width: 70, hide: false },
  { field: 'free_slots', headerName: 'Wolne miejsca', width: 90, hide: false },
  {
    field: 'reserved_slots',
    headerName: 'Zajęte miejsca',
    width: 90,
    hide: false
  },
  {
    field: 'reservations',
    headerName: 'Zarezerwowane',
    width: 90,
    hide: false
  },
  { field: 'confirmed', headerName: 'Potwierdzone', width: 90, hide: false },
  {
    field: 'diagram_accommodated',
    headerName: 'Zakwaterowane miejsca',
    width: 150,
    hide: false
  },
  {
    field: 'diagram_unaccommodated',
    headerName: 'Niezakwaterowane miejsca',
    width: 150,
    hide: false
  },
  {
    field: 'number_of_groups',
    headerName: 'Liczba grup',
    width: 150,
    hide: false
  }
];

export const transportReportsColumns = () => [
  { field: 'date', headerName: 'Termin', width: 120, hide: false },
  { field: 'count', headerName: 'Liczba osób', width: 120, hide: false },
  { field: 'transport', headerName: 'Transport', width: 100, hide: false },
  { field: 'type', headerName: 'Rodzaj', width: 100, hide: false },
  { field: 'resort', headerName: 'Ośrodek', width: 200, hide: false },
  { field: 'camp', headerName: 'Turnus', width: 200, hide: false }
];

export const bankStatementsColumns = (handleEdit, handleConfirmDelete) => [
  {
    field: 'Szczegóły',
    width: 220,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip title="Edytuj" onClick={() => handleEdit(params.row)}>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip
          title="Usuń"
          onClick={() => handleConfirmDelete(params.row.id)}
        >
          <IconButton color="error">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  { field: 'id', headerName: 'ID', width: 200, hide: false, flex: 0.3 },
  {
    field: 'file_name',
    headerName: 'Nazwa pliku',
    width: 200,
    hide: false,
    flex: 0.3
  },
  {
    field: 'created_at',
    headerName: 'Utworzono',
    width: 160,
    hide: false,
    flex: 0.3,
    valueGetter: params => formatDateTime(params.row.created_at)
  }
];

export const dietColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  {
    field: 'season_display',
    headerName: 'Sezon',
    width: 200,
    hide: false,
    flex: 1
  }
];

export const agreementTemplatesColumns = (
  handleDownload,
  handleOpenDeleteModal,
  handleOpenEditModal
) => [
  {
    field: 'Szczegóły',
    width: 150,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip
          title="Pobierz szablon"
          onClick={() => handleDownload(params.row)}
        >
          <IconButton color="info">
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edytuj" onClick={() => handleOpenEditModal(params.row)}>
          <IconButton color="primary">
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Usuń" onClick={() => handleOpenDeleteModal(params.row)}>
          <IconButton color="error">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  {
    field: 'file_name',
    headerName: 'Nazwa Pliku',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'since',
    headerName: 'Obowiązuje od',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'type_display',
    headerName: 'Rodzaj umowy',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'related_functions_display',
    headerName: 'Dotyczy stanowisk',
    width: 200,
    hide: false,
    flex: 1,
    renderCell: params => (
      <Stack spacing={1} direction="row" alignItems="center">
        {params.row.related_functions_display?.length ? (
          <>
            {params.row.related_functions_display
              .map(name => name
                .split(' ')
                .map(word => {
                  const firstChar = word[0];
                  // jeśli pierwszym znakiem jest "(" użyj drugiego znaku
                  if (firstChar === '(' && word.length > 1) {
                    return word[1];
                  }

                  return firstChar;
                })
                .join('')
                .toUpperCase()
              )
              .join(', ')}

            <Tooltip
              title={params.row.related_functions_display?.join(', ') || ''}
            >
              <InfoIcon color="info" fontSize="large" sx={{ px: 1 }} />
            </Tooltip>
          </>
        ) : null}
      </Stack>
    )
  },
  {
    field: 'carbone_template_id',
    headerName: 'Carbone ID',
    width: 200,
    hide: false,
    flex: 1,
    valueGetter: params => {
      const id = params.row.carbone_template_id;
      if (!id) {
        return '';
      }
      const start = id.slice(0, 5);
      const end = id.slice(-5);

      return `${start}...${end}`;
    }
  },
  {
    field: 'updated_at',
    headerName: 'Zaktualizowano',
    width: 200,
    hide: false,
    flex: 1,
    valueGetter: params => formatDateTime(params.row.updated_at)
  }
];

export const invoiceTemplateColumns = (
  handleDownload,
  handleOpenDeleteModal,
  handleOpenEditModal
) => [
  {
    field: 'Szczegóły',
    width: 150,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip
          title="Pobierz szablon"
          onClick={() => handleDownload(params.row)}
        >
          <IconButton color="info">
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edytuj" onClick={() => handleOpenEditModal(params.row)}>
          <IconButton color="primary">
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Usuń" onClick={() => handleOpenDeleteModal(params.row)}>
          <IconButton color="error">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  {
    field: 'file_name',
    headerName: 'Nazwa pliku',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'since',
    headerName: 'Obowiązuje od',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'invoice_type_display',
    headerName: 'Rodzaj dokumentu',
    width: 220,
    hide: false,
    flex: 1
  },
  {
    field: 'carbone_template_id',
    headerName: 'Carbone ID',
    width: 200,
    hide: false,
    flex: 1,
    valueGetter: params => {
      const id = params.row.carbone_template_id;
      if (!id) {
        return '';
      }
      const start = id.slice(0, 5);
      const end = id.slice(-5);

      return `${start}...${end}`;
    }
  },
  {
    field: 'updated_at',
    headerName: 'Zaktualizowano',
    width: 200,
    hide: false,
    flex: 1,
    valueGetter: params => formatDateTime(params.row.updated_at)
  }
];

export const workStandardColumns = (
  handleDownload,
  handleOpenDeleteModal,
  handleOpenEditModal
) => [
  {
    field: 'Szczegóły',
    width: 150,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        {params.row.can_preview && (
          <Tooltip title="Pokaż">
            <IconButton onClick={() => handleDownload(params.row, true)}>
              <RemoveRedEyeIcon color="primary" />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip
          title="Pobierz Plik"
          onClick={() => handleDownload(params.row)}
        >
          <IconButton color="info">
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edytuj" onClick={() => handleOpenEditModal(params.row)}>
          <IconButton color="primary">
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Usuń" onClick={() => handleOpenDeleteModal(params.row)}>
          <IconButton color="error">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  { field: 'name', headerName: 'Nazwa Dokumentu', flex: 1, hide: false },
  { field: 'file_name', headerName: 'Nazwa Pliku', hide: false, flex: 1 },
  {
    field: 'function_types_display',
    headerName: 'Funkcje Pracowników',
    hide: false,
    flex: 1
  },
  { field: 'periods_display', headerName: 'Terminy', hide: false, flex: 1 },
  { field: 'description', headerName: 'Opis Dokumentu', flex: 1, hide: false }
];

export const essentialDocumentColumns = (
  handleDownload,
  handleOpenDeleteModal,
  handleOpenEditModal
) => [
  {
    field: 'Szczegóły',
    width: 150,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip
          title="Pobierz Plik"
          onClick={() => handleDownload(params.row)}
        >
          <IconButton color="info">
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Edytuj" onClick={() => handleOpenEditModal(params.row)}>
          <IconButton color="primary">
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Usuń" onClick={() => handleOpenDeleteModal(params.row)}>
          <IconButton color="error">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  { field: 'name', headerName: 'Nazwa Dokumentu', flex: 1, hide: false },
  { field: 'file_name', headerName: 'Nazwa Pliku', hide: false, flex: 1 },
  { field: 'category_display', headerName: 'Kategoria', hide: false, flex: 1 },
  {
    field: 'function_types_display',
    headerName: 'Funkcje Pracowników',
    hide: false,
    flex: 1
  },
  { field: 'periods_display', headerName: 'Terminy', hide: false, flex: 1 },
  { field: 'resort_display', headerName: 'Ośrodek ZS', hide: false, flex: 1 },
  { field: 'description', headerName: 'Opis Dokumentu', flex: 1, hide: false }
];

export const workStandardStaffColumns = (
  handleDownload,
  handleCheckDocument,
  employeeId,
  showCategory = false
) => [
  {
    field: 'Szczegóły',
    width: 150,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        {params.row.can_preview && (
          <Tooltip title="Pokaż">
            <IconButton onClick={() => handleDownload(params.row, true)}>
              <RemoveRedEyeIcon color="primary" />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip
          title="Pobierz Plik"
          onClick={() => handleDownload(params.row)}
        >
          <IconButton color="info">
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
        {handleCheckDocument && (
          <Tooltip
            title={
              params.row.employee_ids_checked.includes(employeeId)
                ? 'Potwierdzono zapoznanie się z dokumentem'
                : 'Potwierdź zapoznanie się z dokumentem'
            }
          >
            <IconButton
              disabled={params.row.employee_ids_checked.includes(employeeId)}
              color="primary"
              onClick={() => handleCheckDocument(params.row)}
            >
              <CheckIcon />
            </IconButton>
          </Tooltip>
        )}
      </>
    )
  },
  { field: 'name', headerName: 'Nazwa Dokumentu', flex: 1, hide: false },
  { field: 'file_name', headerName: 'Nazwa Pliku', hide: false, flex: 1 },
  {
    field: 'category_display',
    headerName: 'Kategoria',
    flex: 1,
    hide: showCategory ? false : true
  },
  { field: 'description', headerName: 'Opis Dokumentu', flex: 1, hide: false }
];

export const staffAdditionalDocumentsColumns = (
  handleDownload,
  handleCheckDocument
) => [
  {
    field: 'Szczegóły',
    width: 150,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        {params.row.can_preview && (
          <Tooltip title="Pokaż">
            <IconButton onClick={() => handleDownload(params.row, true)}>
              <RemoveRedEyeIcon color="primary" />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip
          title="Pobierz Plik"
          onClick={() => handleDownload(params.row)}
        >
          <IconButton color="info">
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
        {handleCheckDocument && (
          <Tooltip
            title={
              params.row.confirmed_by_staff
                ? 'Potwierdzono zapoznanie się z dokumentem'
                : 'Potwierdź zapoznanie się z dokumentem'
            }
          >
            <span>
              <IconButton
                disabled={params.row.confirmed_by_staff}
                color="primary"
                onClick={() => handleCheckDocument(params.row)}
              >
                <CheckIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
      </>
    )
  },
  { field: 'name', headerName: 'Nazwa Dokumentu', flex: 1, hide: false },
  { field: 'file_name', headerName: 'Nazwa Pliku', flex: 1, hide: false },
  {
    field: 'confirmed_by_office',
    headerName: 'Zapoznany przez biuro',
    flex: 1,
    hide: handleCheckDocument ? true : false,
    renderCell: params => <BooleanColumn {...params} />
  },
  { field: 'description', headerName: 'Opis Dokumentu', flex: 1, hide: false }
];

export const jsonFormsColumns = (handleOpenEditModal, handleOpenNewVersionModal) => [
  {
    field: 'Szczegóły',
    width: 90,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip title="Edytuj" onClick={() => handleOpenEditModal(params.row)}>
          <IconButton color="primary">
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Nowa wersja" onClick={() => handleOpenNewVersionModal(params.row)}>
          <IconButton color="primary">
            <PostAddIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  {
    field: 'identifier',
    headerName: 'Identyfikator',
    width: 200,
    hide: false,
    flex: 1
  },
  { field: 'version', headerName: 'Wersja', width: 200, hide: false, flex: 1 },
  { field: 'description', headerName: 'opis', width: 300, hide: false, flex: 1 }
];

export const ApplicationsColumns = () => [
  { field: 'id', headerName: 'Nr aplikacji', width: 140, hide: false },
  {
    field: 'function_type_display',
    headerName: 'Funkcja',
    width: 140,
    hide: false
  },
  {
    field: 'state_name',
    headerName: 'Status',
    width: 220,
    renderCell: params => <StateColumn {...params} />,
    hide: false
  },
  { field: 'name', headerName: 'Imię', width: 140, hide: false },
  { field: 'surname', headerName: 'Nazwisko', width: 140, hide: false },
  {
    field: 'agreement_number',
    headerName: 'Numer umowy',
    width: 140,
    hide: false
  },
  {
    field: 'correspondence_email',
    headerName: 'Email',
    width: 140,
    hide: false
  },
  { field: 'phone', headerName: 'Numer telefonu', width: 140, hide: false },
  {
    field: 'periods_type',
    headerName: 'Zatrudniony na impreze',
    width: 140,
    hide: false
  },
  { field: 'pesel', headerName: 'PESEL', width: 140, hide: false },
  { field: 'nip', headerName: 'NIP', width: 140, hide: false },
  { field: 'company_name', headerName: 'Nazwa firmy', width: 140, hide: false },
  {
    field: 'city',
    headerName: 'Miasto',
    width: 140,
    hide: false,
    valueGetter: params => params.row?.address?.city
  },
  {
    field: 'house',
    headerName: 'Nr domu/mieszkania',
    width: 140,
    hide: false,
    valueGetter: params => params.row?.address?.house
  },
  {
    field: 'postal_code',
    headerName: 'Miasto',
    width: 140,
    hide: false,
    valueGetter: params => params.row?.address?.postal_code
  },
  {
    field: 'street',
    headerName: 'Ulica',
    width: 140,
    hide: false,
    valueGetter: params => params.row?.address?.street
  },
  {
    field: 'account_number',
    headerName: 'Numer konta',
    width: 140,
    hide: false
  },
  {
    field: 'birth_date',
    headerName: 'Data urodzenia',
    width: 140,
    hide: false
  },
  { field: 'education', headerName: 'Wykształcenie', width: 140, hide: false },
  {
    field: 'current_employee_status',
    headerName: 'Obecny status zatrudnienia',
    width: 140,
    hide: false
  },
  {
    field: 'experience',
    headerName: 'Doświadczenie w pracy na obozach lub zielonych szkołach',
    width: 140,
    hide: false
  },
  {
    field: 'preferred_age_group',
    headerName: 'Preferowana grupa wiekowa',
    width: 140,
    hide: false
  },
  {
    field: 'pedagogical_qualifications_display',
    headerName: 'Uprawnienia pedagogiczne',
    width: 140,
    hide: false
  },
  {
    field: 'additional_qualifications_display',
    headerName: 'Pozostałe uprawnienia',
    width: 140,
    hide: false
  },
  {
    field: 'range_of_skills_display',
    headerName: 'Zakres umiejętności',
    width: 140,
    hide: false
  },
  {
    field: 'company_clothing_size',
    headerName: 'Rozmiar odzieży',
    width: 140,
    hide: false
  },
  {
    field: 'source_of_offer',
    headerName: 'Źródło oferty',
    width: 140,
    hide: false
  },
  {
    field: 'recommended_by',
    headerName: 'Polecony przez',
    width: 140,
    hide: false
  },
  {
    field: 'additional_comments',
    headerName: 'Dodatkowe uwagi',
    width: 140,
    hide: false
  },
  {
    field: 'created_at',
    headerName: 'Data przesłania',
    width: 160,
    hide: false,
    valueGetter: params => formatDateTime(params.row.created_at)
  },
  { field: 'to_pay', headerName: 'Do wypłaty', width: 140, hide: false },
  { field: 'paid_sum', headerName: 'Wypłacono', width: 140, hide: false },
  { field: 'bonus_sum', headerName: 'Bonus', width: 140, hide: false },
  { field: 'supplements', headerName: 'Dodatki', width: 140, hide: false },
  {
    field: 'supplements_info',
    headerName: 'Dodatki z tytułu',
    width: 140,
    hide: false
  },
  {
    field: 'daily_rate',
    headerName: 'Stawka dzienna',
    width: 140,
    hide: false
  },
  // { field: 'hourly_rate', headerName: 'Stawka godzinowa', width: 140, hide: false },
  { field: 'diet', headerName: 'Dieta', width: 140, hide: false },
  {
    field: 'is_documents_returned',
    headerName: 'Podstawowe dokumenty zwrócone',
    width: 140,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'is_additional_documents_returned',
    headerName: 'Dodatkowe dokumenty zwrócone',
    width: 140,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'register_checked',
    headerName: 'Sprawdzony w rejestrze',
    width: 140,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'own_transport',
    headerName: 'Transport własny',
    width: 140,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'transport_has_to_be_picked_up',
    headerName: 'Trzeba odebrać z dworca',
    width: 140,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'transport_info',
    headerName: 'Transport uwagi',
    width: 140,
    hide: false
  },
  {
    field: 'agreement_date_from',
    headerName: 'Data umowy od',
    width: 140,
    hide: false
  },
  {
    field: 'agreement_date_to',
    headerName: 'Data umowy do',
    width: 140,
    hide: false
  },
  {
    field: 'automatic_notifications',
    headerName: 'Powiadomienia automatyczne',
    width: 140,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'manual_notifications',
    headerName: 'Powiadomienia manualne',
    width: 140,
    hide: false,
    renderCell: params => <BooleanColumn {...params} />
  },
  {
    field: 'works_in_additional_periods_display',
    headerName: 'Czy świadczy usługi w dodatkowych terminach',
    width: 140,
    hide: false
  },
  {
    field: 'terminy_ol',
    headerName: 'Dostępny w terminach (Lato)',
    width: 140,
    hide: false,
    valueGetter: params => {
      let value = '';

      params.row.ol_periods_choices.forEach(element => {
        if (params.row.periods.includes(element.value)) {
          value += `${element.label}, `;
        }
      });

      return value;
    }
  },
  {
    field: 'terminy_zs',
    headerName: 'Dostępny w terminach (ZS)',
    width: 140,
    hide: false,
    valueGetter: params => {
      let value = '';

      params.row.zs_periods_choices.forEach(element => {
        if (params.row.periods.includes(element.value)) {
          value += `${element.label}, `;
        }
      });

      return value;
    }
  },
  {
    field: 'remaining_payout',
    headerName: 'Pozostało do wypłaty',
    width: 140,
    hide: false
  },
  {
    field: 'new_document_added_by_staff',
    headerName: 'Nowy dokument od pracownika',
    width: 160,
    align: 'center',
    renderCell: params => <AlertColumn {...params} />,
    hide: false
  },
  {
    field: 'agreement_signing_date',
    headerName: 'Data podpisania umowy',
    width: 160,
    hide: false,
    valueGetter: params => formatDate(params.row.agreement_signing_date)
  }
];

export const EmployeesColumns = () => [
  { field: 'name', headerName: 'Imię', width: 140, hide: false },
  { field: 'surname', headerName: 'Nazwisko', width: 140, hide: false },
  {
    field: 'state_name',
    headerName: 'Status',
    width: 220,
    renderCell: params => <StateColumn {...params} />,
    hide: false
  },
  {
    field: 'correspondence_email',
    headerName: 'Email',
    width: 140,
    hide: false
  },
  { field: 'phone', headerName: 'Numer telefonu', width: 140, hide: false },
  {
    field: 'birth_date',
    headerName: 'Data urodzenia',
    width: 140,
    hide: false
  },
  { field: 'pesel', headerName: 'PESEL', width: 140, hide: false },
  { field: 'nip', headerName: 'NIP', width: 140, hide: false },
  { field: 'company_name', headerName: 'Nazwa firmy', width: 140, hide: false },
  {
    field: 'city',
    headerName: 'Miasto',
    width: 140,
    hide: false,
    valueGetter: params => params.row?.address?.city
  },
  {
    field: 'house',
    headerName: 'Nr domu/mieszkania',
    width: 140,
    hide: false,
    valueGetter: params => params.row?.address?.house
  },
  {
    field: 'postal_code',
    headerName: 'Miasto',
    width: 140,
    hide: false,
    valueGetter: params => params.row?.address?.postal_code
  },
  {
    field: 'street',
    headerName: 'Ulica',
    width: 140,
    hide: false,
    valueGetter: params => params.row?.address?.street
  },
  {
    field: 'account_number',
    headerName: 'Numer konta',
    width: 140,
    hide: false
  },
  {
    field: 'place_of_birth',
    headerName: 'Miejsce urodzenia',
    width: 140,
    hide: false
  },
  {
    field: 'a_id',
    headerName: 'Numer aplikacji',
    width: 140,
    valueGetter: params => params.row?.latest_application?.id
  },
  {
    field: 'a_function',
    headerName: 'Funkcja',
    width: 140,
    valueGetter: params => params.row?.latest_application?.function_type_display
  },
  {
    field: 'a_periods_type',
    headerName: 'Zatrudniony na impreze',
    width: 140,
    valueGetter: params => params.row?.latest_application?.periods_type,
    hide: false
  },
  {
    field: 'a_education',
    headerName: 'Wykształcenie',
    width: 140,
    valueGetter: params => params.row?.latest_application?.education,
    hide: false
  },
  {
    field: 'a_current_employee_status',
    headerName: 'Obecny status zatrudnienia',
    width: 140,
    valueGetter: params => params.row?.latest_application?.current_employee_status,
    hide: false
  },
  {
    field: 'a_experience',
    headerName: 'Doświadczenie w pracy na obozach lub zielonych szkołach',
    width: 140,
    valueGetter: params => params.row?.latest_application?.experience,
    hide: false
  },
  {
    field: 'a_preferred_age_group',
    headerName: 'Preferowana grupa wiekowa',
    width: 140,
    valueGetter: params => params.row?.latest_application?.preferred_age_group,
    hide: false
  },
  {
    field: 'a_pedagogical_qualifications_display',
    headerName: 'Uprawnienia pedagogiczne',
    width: 140,
    valueGetter: params => params.row?.latest_application?.pedagogical_qualifications_display,
    hide: false
  },
  {
    field: 'a_additional_qualifications_display',
    headerName: 'Pozostałe uprawnienia',
    width: 140,
    valueGetter: params => params.row?.latest_application?.additional_qualifications_display,
    hide: false
  },
  {
    field: 'a_range_of_skills_display',
    headerName: 'Zakres umiejętności',
    width: 140,
    valueGetter: params => params.row?.latest_application?.range_of_skills_display,
    hide: false
  },
  {
    field: 'a_company_clothing_size',
    headerName: 'Rozmiar odzieży',
    width: 140,
    valueGetter: params => params.row?.latest_application?.company_clothing_size,
    hide: false
  },
  {
    field: 'a_source_of_offer',
    headerName: 'Źródło oferty',
    width: 140,
    valueGetter: params => params.row?.latest_application?.source_of_offer,
    hide: false
  },
  {
    field: 'a_recommended_by',
    headerName: 'Polecony przez',
    width: 140,
    valueGetter: params => params.row?.latest_application?.recommended_by,
    hide: false
  },
  {
    field: 'a_additional_comments',
    headerName: 'Dodatkowe uwagi',
    width: 140,
    valueGetter: params => params.row?.latest_application?.additional_comments,
    hide: false
  },
  {
    field: 'a_bonus',
    headerName: 'Bonus',
    width: 140,
    valueGetter: params => params.row?.latest_application?.bonus_sum,
    hide: false
  },
  {
    field: 'a_supplements',
    headerName: 'Dodatki',
    width: 140,
    valueGetter: params => params.row?.latest_application?.supplements,
    hide: false
  },
  {
    field: 'a_daily_rate',
    headerName: 'Stawka dzienna',
    width: 140,
    valueGetter: params => params.row?.latest_application?.daily_rate,
    hide: false
  },
  // { field: 'a_hourly_rate', headerName: 'Stawka godzinowa', width: 140, valueGetter: params => params.row?.latest_application?.hourly_rate, hide: false },
  {
    field: 'a_diet',
    headerName: 'Dieta',
    width: 140,
    valueGetter: params => params.row?.latest_application?.diet,
    hide: false
  },
  {
    field: 'points_sum',
    headerName: 'Punkty Sun-Active',
    width: 140,
    valueGetter: params => params.row?.points_sum,
    hide: false
  },
  {
    field: 'average_final_grade',
    headerName: 'Średnia ocen',
    width: 140,
    valueGetter: params => params.row?.average_final_grade,
    hide: false
  }
];

export const attachmentsColumns = (
  handleDelete,
  handleSetActiveDocument,
  isEmployee = false
) => [
  {
    field: 'Szczegóły',
    width: 150,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip title="Zobacz plik">
          <IconButton
            color="primary"
            onClick={() => handleSetActiveDocument(
              params.row.id,
              params.row.file_name,
              params.row.file
            )
            }
          >
            <RemoveRedEyeIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Pobierz plik">
          <IconButton
            color="info"
            href={params.row.file_download_url}
            download={params.row.file_name}
          >
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Usuń">
          <IconButton color="error" onClick={() => handleDelete(params.row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  {
    field: 'file_name',
    headerName: 'Nazwa Pliku',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'created_at',
    headerName: 'Data dodania',
    width: 200,
    hide: false,
    flex: 1,
    valueGetter: params => formatDateTime(params.row.created_at)
  },
  ...(isEmployee
    ? [
      {
        field: 'source',
        headerName: 'Źródło',
        width: 200,
        hide: false,
        flex: 1
      }
    ]
    : [])
];

export const BooleanColumn = React.memo(({ yesno = false, value }) => yesno ? (
  <div>
    <Typography>{value ? 'Tak' : 'Nie'}</Typography>
  </div>
) : (
  <div
    className="d-flex justify-content-between align-items-center"
    style={{ cursor: 'pointer' }}
  >
    {value ? (
      <FontAwesomeIcon icon={['fas', 'check']} color="green" size="xs" />
    ) : (
      <FontAwesomeIcon icon={['fas', 'times']} color="red" size="xs" />
    )}
  </div>
)
);

export const NullBooleanColumn = React.memo(params => (
  <div
    className="d-flex justify-content-between align-items-center"
    style={{ cursor: 'pointer' }}
  >
    {params.value === true ? (
      <FontAwesomeIcon icon={['fas', 'check']} color="green" size="xs" />
    ) : params.value === false ? (
      <FontAwesomeIcon icon={['fas', 'times']} color="red" size="xs" />
    ) : (
      <RemoveIcon />
    )}
  </div>
));

export const StateColumn = React.memo(params => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      backgroundColor: params.row.state_color,
      color: 'white',
      textAlign: 'center',
      fontWeight: 'bold',
      borderRadius: '4px'
    }}
  >
    <p>{params.value}</p>
  </div>
));

export const AlertColumn = React.memo(params => (
  <div
    className="d-flex justify-content-between align-items-center"
    style={{ cursor: 'pointer' }}
  >
    {params.value ? (
      <FontAwesomeIcon icon={['fas', 'exclamation']} color="red" size="xs" />
    ) : (
      ''
    )}
  </div>
));

export const dynamicSectionsColumns = handleOpenEditModal => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip title="Edytuj" onClick={() => handleOpenEditModal(params.row)}>
          <IconButton color="primary">
            <EditIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  {
    field: 'agreement_template_file_name',
    headerName: 'Szablon',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'agreement_section_type_display',
    headerName: 'Rodzaj sekcji',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'agreement_type_display',
    headerName: 'Rodzaj umowy',
    width: 300,
    hide: false,
    flex: 1
  }
];

export const bonusesColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false },
  { field: 'description', headerName: 'Szczegóły', width: 600, hide: false },
  { field: 'value', headerName: 'Wartość', width: 250, hide: false }
];

export const employeeReviewsColumns = (
  handleEdit,
  handleDelete,
  isManager = false
) => [
  {
    field: 'Szczegóły',
    width: 80,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip title="Edytuj">
          <IconButton color="info" onClick={() => handleEdit(params.row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Usuń">
          <IconButton color="error" onClick={() => handleDelete(params.row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  {
    field: 'author_name',
    headerName: 'Autor',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'application',
    headerName: 'Aplikacja',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'function_type_display',
    headerName: 'Stanowisko',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'final_grade',
    headerName: 'Ocena',
    width: 100,
    hide: false,
    flex: 1
  },
  {
    field: 'camp_name',
    headerName: 'Obóz',
    width: 250,
    hide: isManager,
    flex: 1
  },
  {
    field: 'event_display',
    headerName: 'Impreza',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'resort_name',
    headerName: 'Ośrodek',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'period_display',
    headerName: 'Termin',
    width: 250,
    hide: isManager,
    flex: 1
  },
  {
    field: 'created_at',
    headerName: 'Data dodania',
    width: 200,
    hide: false,
    flex: 1,
    valueGetter: params => formatDateTime(params.row.created_at)
  }
];

export const employeeSunActiveRecordColumns = (handleEdit, handleDelete) => [
  {
    field: 'Szczegóły',
    width: 80,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip title="Edytuj">
          <IconButton color="info" onClick={() => handleEdit(params.row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Usuń">
          <IconButton color="error" onClick={() => handleDelete(params.row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  {
    field: 'author_name',
    headerName: 'Autor',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'application',
    headerName: 'Aplikacja',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'function_type_display',
    headerName: 'Stanowisko',
    width: 250,
    hide: false,
    flex: 1
  },
  {
    field: 'value',
    headerName: 'Punkty',
    width: 50,
    hide: false,
    flex: 1,
    valueGetter: params => params.row.value > 0 ? `+${params.row.value}` : params.row.value
  },
  {
    field: 'dynamic_category_display',
    headerName: 'Kategoria',
    width: 200,
    hide: false,
    flex: 1
  },
  { field: 'camp_name', headerName: 'Obóz', width: 300, hide: false, flex: 1 },
  {
    field: 'created_at',
    headerName: 'Data dodania',
    width: 200,
    hide: false,
    flex: 1,
    valueGetter: params => formatDateTime(params.row.created_at)
  }
];

export const AccountsColumns = () => [
  { field: 'first_name', headerName: 'Imię', width: 140, hide: false },
  { field: 'last_name', headerName: 'Nazwisko', width: 140, hide: false },
  { field: 'email', headerName: 'E-mail', width: 240, hide: false },
  {
    field: 'is_active_display',
    headerName: 'Aktywne',
    width: 140,
    hide: false
  },
  { field: 'groups_display', headerName: 'Grupa', width: 140, hide: false }
];

export const managerEmployeesTableColumns = handleEdit => [
  {
    field: 'Szczegóły',
    width: 150,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <>
        <Tooltip title="Edytuj" onClick={() => handleEdit(params.row.id)}>
          <IconButton color="info">
            <EditIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  },
  { field: 'name', headerName: 'Imię', flex: 1, hide: false },
  { field: 'surname', headerName: 'Nazwisko', flex: 1, hide: false },
  {
    field: 'function_type_display',
    headerName: 'Stanowisko',
    flex: 1,
    hide: false
  },
  {
    field: 'review',
    headerName: 'Wystawiono opinię',
    hide: false,
    renderCell: params => (
      <BooleanColumn value={(params.row.reviews || []).length > 0} />
    ),
    flex: 1
  },
  {
    field: 'points',
    headerName: 'Wystawiono punkty',
    renderCell: params => (
      <BooleanColumn value={(params.row.points || []).length > 0} />
    ),
    flex: 1,
    hide: false
  }
];

export const packagesColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  {
    field: 'period_display',
    headerName: 'Termin',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'season_display',
    headerName: 'Sezon',
    width: 200,
    hide: false,
    flex: 1
  },
  {
    field: 'resorts_display',
    headerName: 'Ośrodki',
    width: 200,
    hide: false,
    flex: 1
  }
];

export const sunActiveCateryColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false },
  { field: 'type_display', headerName: 'Rodzaj', width: 600, hide: false },
  { field: 'value', headerName: 'Wartość punktowa', width: 600, hide: false }
];

export const availabilityStatusColumns = handleDetailsCheck => [
  {
    field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    )
  },
  { field: 'id', headerName: 'ID', width: 50, hide: false },
  { field: 'description', headerName: 'Opis', width: 320, hide: false },
  { field: 'status_display', headerName: 'Status', width: 200, hide: false },
  { field: 'availability_level_display', headerName: 'Poziom dostępności', width: 200, hide: false },
  { field: 'season_display', headerName: 'Sezon', width: 200, hide: false },
  { field: 'date_from', headerName: 'Data od', width: 200, hide: false },
  { field: 'date_to', headerName: 'Data do', width: 200, hide: false }
];

export const TfgFeedsColumns = () => [
  { field: 'id', headerName: 'ID', width: 60, hide: false },
  { field: 'agreement', headerName: 'Umowa', width: 140, hide: false },
  { field: 'order', headerName: 'Zamówienie', width: 160, hide: false },
  { field: 'agreement_annex', headerName: 'Aneks', width: 140, hide: false },
  { field: 'invoice', headerName: 'Dokument', width: 140, hide: false },
  {
    field: 'operation_type_display',
    headerName: 'Operacja',
    width: 140,
    hide: false
  },
  {
    field: 'status_display',
    headerName: 'Status',
    width: 120,
    hide: false,
    renderCell: params => {
      const colors = {
        PENDING: '#ffc107',
        PROCESSING: '#17a2b8',
        SENT: '#0d6efd',
        ACCEPTED: '#198754',
        REJECTED: '#dc3545',
        ERROR: '#6c757d'
      };

      return (
        <span
          style={{
            fontWeight: 600,
            color: colors[params.row.status] || '#6c757d'
          }}
        >
          ● {params.value}
        </span>
      );
    }
  },
  {
    field: 'attempts',
    headerName: 'Próby',
    width: 70,
    hide: false
  },
  {
    field: 'processed_at',
    headerName: 'Przetworzono',
    width: 180,
    hide: false,
    valueGetter: params => formatDateTime(params.row.processed_at)
  },
  {
    field: 'deadline_at',
    headerName: 'Deadline',
    width: 180,
    hide: false,
    valueGetter: params => formatDateTime(params.row.deadline_at)
  },
  {
    field: 'created_at',
    headerName: 'Utworzono',
    width: 180,
    hide: false,
    valueGetter: params => formatDateTime(params.row.created_at)
  }
];

export const activityCategoryColumns = () => [
  { field: 'id', headerName: 'ID', width: 100, hide: false },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 }
];
